import {
  SIGNUP_SUBMITTED,
  RESET_PASSWORD_EMAIL_SEND_SUCCESS,
  RESET_PASSWORD_EMAIL_SEND_FAILURE
} from '../constants';
import { createNewUser, setCompanyClaim } from '../../services/authServices';

export const signIn = credentials => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {})
      .catch(err => {
        dispatch({ type: 'LOGIN_ERROR', err });
      });
  };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: 'SIGNOUT_SUCCESS' });
      });
  };
};

export const signUp = newUser => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    dispatch({ type: SIGNUP_SUBMITTED });
    createNewUser(newUser, firebase, firestore)
      .then(idToken => {
        setCompanyClaim(idToken, firebase).then(() => {
          dispatch({ type: 'SIGNUP_SUCCESS' });
        });
      })
      .catch(err => {
        dispatch({ type: 'SIGNUP_ERROR', err });
      });
  };
};

export const resetAccount = email => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();

    const auth = firebase.auth();
    auth
      .sendPasswordResetEmail(email)
      .then(() => {
        dispatch({ type: RESET_PASSWORD_EMAIL_SEND_SUCCESS });
      })
      .catch(err => {
        dispatch({ type: RESET_PASSWORD_EMAIL_SEND_FAILURE });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/authActions.js